export const api = {
    GET_ROLES_DATA: "/api/roleManagement/rolesData",
    ADD_ROLE: "/api/roleManagement/add"
}